<script>
	import Select, { Option } from "@smui/select";
	import { selectedOrganizationLanguages, selectedLanguage, selectedLanguageName, setupComplete, languages } from "../stores";

	$: console.log($languages);
	$: console.log($selectedLanguage);
	$: console.log($selectedLanguageName);
</script>

{#if $setupComplete}
	<div class="main-select language-selection">
		<Select
			bind:value={$selectedLanguage}
			variant="outlined"
			label="Language"
			disabled={$selectedOrganizationLanguages.length === 1}
		>
			{#each $languages as l}
				<Option style={!$selectedOrganizationLanguages.includes(l.id) ? "display: none;" : ""} value={l.id}
					>{l.name}</Option
				>
			{/each}
		</Select>
	</div>
{/if}

<style lang="scss">
	.language-selection {
		:global(.mdc-select--disabled .mdc-select__dropdown-icon) {
			transition: opacity 0.3s ease;
			opacity: 0;
		}
	}
</style>
